// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@tps/App/Components/Common/XngZone";
import { checkoutSharedStyles } from "@tps/App/SharedStyles/CheckoutSharedStyles";
import { cartPageContainerStyles } from "@tps/Overrides/Widgets/Cart/CartPageContainer";
import React from "react";
import { css } from "styled-components";

export interface OrderConfirmationPageContainerStyles {
    container?: GridContainerProps;
    headerGridItem?: GridItemProps;
    accountSignUpGridItem?: GridItemProps;
    orderInformationGridItem?: GridItemProps;
    orderTotalGridItem?: GridItemProps;
    productListGridItem?: GridItemProps;
    // XNG-Change
    headerWrapper?: InjectableCss;
    wrapper?: InjectableCss;
}

export const orderConfirmationPageContainerStyles: OrderConfirmationPageContainerStyles = {
    headerGridItem: {
        css: css`
            order: 1;
        `,
        width: 12,
    },
    accountSignUpGridItem: {
        css: css`
            order: 2;
        `,
        width: 12,
    },
    orderInformationGridItem: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 3;
                    `,
                    css`
                        order: 3;
                    `,
                    css`
                        order: 2;
                    `,
                    css`
                        order: 2;
                    `,
                    css`
                        order: 2;
                    `,
                ])}
        `,
        width: [12, 12, 6, 8, 8],
    },
    orderTotalGridItem: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                    `,
                    css`
                        order: 2;
                    `,
                    css`
                        order: 3;
                    `,
                    css`
                        order: 3;
                    `,
                    css`
                        order: 3;
                    `,
                ])}
        `,
        width: [12, 12, 6, 4, 4],
    },
    productListGridItem: {
        css: css`
            order: 4;
        `,
        width: [12, 12, 12, 8, 8],
    },
};

const styles = orderConfirmationPageContainerStyles;

const OrderConfirmationPageContainer = ({ id }: WidgetProps) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...checkoutSharedStyles.leftSection}>
                <XngZone contentId={id} zoneName="Content0" hint="Zone For PageHeader" />
                <XngZone contentId={id} zoneName="Content1" hint="Zone For AccountSignUpMessage" />
                <StyledWrapper {...checkoutSharedStyles.separator} />
                <StyledWrapper {...checkoutSharedStyles.addressesAndOrderDetailsSection}>
                    <XngZone contentId={id} zoneName="Content2" hint="Zone For OrderInformation" />
                </StyledWrapper>
                <StyledWrapper {...checkoutSharedStyles.separator} />
                <StyledWrapper {...checkoutSharedStyles.productsSection}>
                    <XngZone contentId={id} zoneName="Content3" hint="Zone For ProductList" />
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...checkoutSharedStyles.rightSection}>
                <StyledWrapper {...cartPageContainerStyles.cartTotalContainer}>
                    <XngZone contentId={id} zoneName="Content4" hint="Zone For OrderConfirmationTotal" />
                </StyledWrapper>
                <XngZone contentId={id} zoneName="Content5" hint="Zone For AdditionalContent" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderConfirmationPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Order Confirmation",
        allowedContexts: ["OrderConfirmationPage"],
    },
};
export default widgetModule;
